import authService from '@/api/authService';
import ErrorAlert from '@/components/errorAlert';
import ProviderContainer from '@/components/providerContainer';
import { tableTheme, theme } from '@/theme';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { DatePickerProvider, TableSettingsProvider } from 'schummar-table';
import { TranslationContextProvider } from 'translations';

export const Route = createRootRouteWithContext<{
    loginState: 'pending' | 'loggedIn' | 'loggedOut';
}>()({
    component: RootPage,
    errorComponent(props) {
        return (
            <MantineProvider>
                <ErrorAlert {...props} />
            </MantineProvider>
        );
    },
});

function RootPage() {
    const [locale] = authService.userLanguage.useCache();

    return (
        <ProviderContainer
            providers={[
                <MantineProvider theme={theme} key="mantine" />,
                <ModalsProvider key="modals" />,
                <DatesProvider settings={{ locale }} key="dates" />,
                <DatePickerProvider locale={locale} key="datePicker" />,
                <TableSettingsProvider theme={tableTheme} key="tableSettings" />,
                <TranslationContextProvider locale={locale} key="translation" />,
            ]}
        >
            <Outlet />
        </ProviderContainer>
    );
}
